import React from 'react';
import { LineChart, Line, ResponsiveContainer, Tooltip } from 'recharts';
import Icon from 'components/AppIcon';

const spark = (base, len = 8, variance = 0.08) =>
  Array.from({ length: len }, (_, i) => ({ v: +(base * (1 + (Math.random() - 0.5) * variance + i * 0.01))?.toFixed(2) }));

const KPIS = [
  { label: 'Installed Capacity', value: '248 MW', sub: 'Nameplate capacity', trend: 'stable', data: spark(248, 8, 0.02), color: 'var(--color-primary)' },
  { label: 'Utilisation Rate', value: '87.4%', sub: 'P50 basis', trend: 'up', data: spark(87, 8, 0.04), color: '#059669' },
  { label: 'Revenue Run-rate', value: '£42.1m', sub: 'Annualised', trend: 'up', data: spark(42, 8, 0.06), color: '#7C3AED' },
  { label: 'OpEx', value: '£8.7m', sub: 'Annualised', trend: 'down', data: spark(8.7, 8, 0.05), color: '#DC2626' },
  { label: 'EBITDA Margin', value: '79.3%', sub: 'LTM basis', trend: 'up', data: spark(79, 8, 0.03), color: '#059669' },
  { label: 'DSCR', value: '1.42x', sub: 'Debt service coverage', trend: 'stable', data: spark(1.42, 8, 0.04), color: 'var(--color-primary)' },
];

const TREND_ICONS = { up: 'TrendingUp', down: 'TrendingDown', stable: 'Minus' };
const TREND_COLORS = { up: '#059669', down: '#DC2626', stable: 'var(--color-muted-foreground)' };

export default function OperationalKPIsTab() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-heading font-semibold text-foreground" style={{ fontSize: '0.9375rem' }}>Operational KPIs</h3>
          <p className="font-caption text-muted-foreground text-xs mt-0.5">Last updated: 28 Feb 2026 · Source: Asset Manager Monthly Report · Sample data</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {KPIS?.map((kpi) => (
          <div key={kpi?.label} className="card" style={{ padding: '18px 20px' }}>
            <div className="flex items-start justify-between gap-2 mb-3">
              <div>
                <p className="font-caption text-muted-foreground" style={{ fontSize: '0.7rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>{kpi?.label}</p>
                <p className="font-heading font-semibold text-foreground mt-0.5" style={{ fontSize: '1.375rem', lineHeight: 1.2 }}>{kpi?.value}</p>
                <p className="font-caption text-muted-foreground text-xs mt-0.5">{kpi?.sub}</p>
              </div>
              <div className="flex items-center gap-1 mt-1">
                <Icon name={TREND_ICONS?.[kpi?.trend]} size={16} color={TREND_COLORS?.[kpi?.trend]} />
              </div>
            </div>
            <ResponsiveContainer width="100%" height={48}>
              <LineChart data={kpi?.data} margin={{ top: 2, right: 2, left: 2, bottom: 2 }}>
                <Line type="monotone" dataKey="v" stroke={kpi?.color} strokeWidth={1.8} dot={false} />
                <Tooltip
                  contentStyle={{ fontSize: 11, borderRadius: 6, border: '1px solid var(--color-border)', padding: '4px 8px' }}
                  formatter={(v) => [v, kpi?.label]}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        ))}
      </div>
      <div className="flex items-start gap-2 px-4 py-3 rounded-lg border border-border bg-muted/20">
        <Icon name="Info" size={14} color="var(--color-muted-foreground)" className="flex-shrink-0 mt-0.5" />
        <p className="font-caption text-muted-foreground text-xs">
          KPI data sourced from asset manager monthly operational reports. Figures are unaudited and subject to revision. All values are sample data for demonstration purposes only.
        </p>
      </div>
    </div>
  );
}
